import ListTable from 'components/Control/CheckListMaq/ListTable'
import TableLoader from 'components/ui/Table/TableLoader'
import { ModalContext } from 'contexts/ModalContext'
import { TitleContext } from 'contexts/TitleContext'
import useFetch from 'hooks/useFetch'
import { useContext, useEffect } from 'react'
import { useLocation } from 'wouter'

const CheckListMaqList = () => {
  const { setTitle } = useContext(TitleContext)
  const [checklistList, checklistListAction] = useFetch()
  const [, setLocation] = useLocation()
  const { handleModal } = useContext(ModalContext)

  const [userList, userListAction] = useFetch()

  const [equipmentList, equipmentListAction] = useFetch()

  useEffect(() => {
    // Set title
    const checklistTitle = {
      name: 'Check List (MAQ)',
      buttons: [
        {
          name: 'Nou Check List',
          link: `/checklistmaq/nou/`
        }
      ]
    }
    setTitle(checklistTitle)

    // GET user
    const userListAPIParams = {
      url: `user`,
      method: 'GET',
      messageKo: 'Error al recuperar dades del ECAP'
    }
    userListAction(userListAPIParams)

    // GET equipment
    const equipmentListAPIParams = {
      url: `inventorymachine/isTool`,
      method: 'GET',
      messageKo: 'Error al recuperar dades'
    }
    equipmentListAction(equipmentListAPIParams)

    const checklistListAPIParams = {
      url: `checklistmaq`,
      method: 'GET',
      messageKo: 'Error al recuperar dades'
    }
    checklistListAction(checklistListAPIParams)

    //* Avoid bug that when inventory is deleted and user is redirected to this page, modal is still open
    handleModal('hide')
  }, [])

  const handleClick = (e, item) => {
    e.preventDefault()
    setLocation(`/checklistmaq/${item.Id}`)
  }

  return checklistList.data ? (
    <div className="flex flex-col w-full p-4 bg-white">
      <ListTable
        users={userList}
        equipments={equipmentList}
        items={checklistList.data}
        handleClick={handleClick}
      />
    </div>
  ) : (
    <div className="flex justify-center w-full">
      <div className="w-10/12">
        <TableLoader />
      </div>
    </div>
  )
}

export default CheckListMaqList
